import React, { useState } from 'react';
import { TextField, Button, Typography, Paper, Box, Grid, CircularProgress } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { verifyOtpAndResetPassword } from '../api';

function OtpVerificationPage() {
  const [email, setEmail] = useState(''); // Add state for email
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
    const [loading, setLoading] = useState(false); // Add loading state
  
  // const { email: emailParam } = useParams(); // Remove useParams for email
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      setMessage('');
      return;
    }
    setLoading(true); // Start loading
    setMessage(''); // Clear previous messages/errors
    setError('');

    // Pass the email from the state to the API call
    try {
      await verifyOtpAndResetPassword(email, otp, password);
      setMessage('Password has been reset successfully.');
      setError('');
      navigate('/login');
    } catch (err) {
      setError(err.message || 'Failed to reset password.');
      setMessage('');
    } finally {
      setLoading(false); // End loading
    }
  };

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid item xs={12} sm={8} md={5} lg={4}>
        <Paper elevation={6} sx={{ p: 3 }}>
          <Typography variant="h5" align="center" gutterBottom>
            Verify OTP and Reset Password
          </Typography>
          {message && <Typography color="success" align="center" sx={{ mb: 2 }}>{message}</Typography>}
          {error && <Typography color="error" align="center" sx={{ mb: 2 }}>{error}</Typography>}
          <form onSubmit={handleSubmit}>
            {/* Add TextField for email */}
            <Box mb={2}>
              <TextField
                fullWidth
                label="Email Address"
                variant="outlined"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading} // Disable input while loading
              />
            </Box>
            <Box mb={2}>
              <TextField
                fullWidth
                label="OTP"
                variant="outlined"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
                disabled={loading} // Disable input while loading
              />
            </Box>
            <Box mb={2}>
              <TextField
                fullWidth
                label="New Password"
                variant="outlined"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading} // Disable input while loading
              />
            </Box>
            <Box mb={3}>
              <TextField
                fullWidth
                label="Confirm New Password"
                variant="outlined"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                disabled={loading} // Disable input while loading
              />
            </Box>
            <Button variant="contained" color="primary" type="submit" fullWidth
              disabled={loading} // Disable button while loading
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null} // Show spinner
            >
              {loading ? 'Resetting...' : 'Reset Password'} {/* Change text while loading */}
            </Button>
          </form>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default OtpVerificationPage;